import React, { Component } from 'react';
import { bool, func } from 'prop-types';
import { Paperclip, Send, X } from 'react-feather';

import { ACCEPTED_FILE_TYPES } from '../../constants/AppConstants';
import LoadingState from '../LoadingState';

import cx from 'classnames';
import s from './MessageInput.css';


export default class MessageInput extends Component {
    static propTypes = {
        isLoadingReply: bool,
        replyHandler: func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            input: '',
            attachment: {},
        };

        // This is so we can assign it focus after adding attachment
        this.messageTextInput = React.createRef();
    }

    submitHandler = event => {
        // Stop the form from refreshing the page on submit
        event.preventDefault();

        const { attachment, input } = this.state;
        const { replyHandler } = this.props;

        // Don't submit if the message and attachment fields are both blank.
        if ((!input || input.length === 0) && (!attachment || !Object.keys(attachment).length)) {
            return;
        }

        // Callback with the input message and attachment.
        replyHandler(input, attachment);

        // Clear state
        this.setState({ input: '', attachment: {} });
    };

    inputHandler = event => this.setState({ input: event.target.value });

    handleFileChange = event => {
        this.setState({ attachment: event.target.files });
        this.messageTextInput.current.focus();
    };

    removeFile = () => {
        this.setState({ attachment: {} });
        this.fileUpload.value = "";
    };

    render = () => {
        const { isLoadingReply } = this.props;
        const { attachment, input } = this.state;

        return (
            <nav className={s.component}>
                <form
                    id="sendMessageForm"
                    className={cx({
                        [s.form]: true,
                        [s.attachmentsShowing]: attachment[0] && attachment[0].name
                    })}
                    onSubmit={this.submitHandler}
                    encType="multipart/form-data"
                    method="post"
                >
                    <input type="hidden" value="trickChromesAutoCompleteBullshit" />
                    <label
                        htmlFor="fileUpload"
                        className={cx(s.fileUpload, 'icon-link')}
                    >
                        <input
                            id="fileUpload"
                            ref={ref=> this.fileUpload = ref}
                            type="file"
                            onChange={this.handleFileChange}
                            accept={ACCEPTED_FILE_TYPES}
                            disabled={isLoadingReply}
                        />
                        <Paperclip size={16} />
                    </label>
                    {attachment[0] && attachment[0].name &&
                        <div className={s.file}>
                            <span className={s.name}>
                                {attachment[0].name}
                            </span>
                            <button
                                className={s.remove}
                                onClick={this.removeFile}
                                title={`Remove ${attachment[0].name}`}
                            >
                                <X className={s.icon} size={16}/>
                            </button>
                        </div>
                    }
                    <input
                        className={s.input}
                        id="messageInput"
                        type="text"
                        onChange={this.inputHandler}
                        value={input}
                        placeholder="Enter message..."
                        ref={this.messageTextInput}
                        name="message"
                        autoComplete="message"
                        disabled={isLoadingReply}
                    />
                    <button
                        aria-label="Send message"
                        className={s.btn}
                        disabled={isLoadingReply}
                        id="sendMessageButton"
                        type="submit"
                    >
                        {isLoadingReply ?
                            <LoadingState context="sendMessageForm"/> :
                            <Send className={s.icon} size={24} />
                        }
                    </button>
                </form>
            </nav>
        );
    }
}
